<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @delete-items="deleteItems"
                            @new-item="addItem"
                            @row-click="detailItem"
                            ref="gofixTable">
                            <template slot="gofix_table:term_type" slot-scope="row">
                                {{ row.item.term_type ? `${row.item.term_type}-term` : '' }}
                                <!-- {{ row.item |showDateTerm(0) }} -->
                            </template>
                            <template slot="gofix_table:start_date" slot-scope="row">
                                {{ row.item.start_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                                <!-- {{ row.item|showDateTerm(2) }} -->
                            </template>
                            <template slot="gofix_table:end_date" slot-scope="row">
                                {{ row.item.end_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                                <!-- {{ row.item|showDateTerm(1) }} -->
                            </template>
                            <template slot="gofix_table:contract_sum" slot-scope="row">
                                {{ row.item.sum | formatMoney }}
                            </template>
                            <template slot="gofix_table:status" slot-scope="row">
                                <span class="opacity-06">{{ row.item.status }}</span>
                            </template>
                            <template slot="gofix_table:name_organization" slot-scope="row">
                                <span>{{ row.item.client ? row.item.client.name : '' }}</span>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal :no-close-on-backdrop="true" id="modal-Contract" title="Create New Contract" hide-footer :centered="true" ref="modal-Contract">
                <b-form class="pb-20">
                    <gofix-form-dropdown
                            label="Select Customer"
                            desc="e.g. Contract with ABC"
                            :clearSearchOnSelect="false"
                            v-model="contract.client"
                            :options="clients"
                            vLabel="name" :filterable="false"
                            @search="searchOrganization">
                    </gofix-form-dropdown>
                    <b-form-checkbox :disabled="!isNewCustomer" v-model="contract.newCustomer" class="newCheckBoxCustomer"><span>New Customer?</span></b-form-checkbox>
                    <gofix-form-dropdown
                            label="Select FMCompany"
                            v-model="contract.supplier"
                            :disabled="disabled"
                            :options="suppliers"
                            vLabel="name"
                            :filterable="false"
                            @search="searchFMCompany">
                    </gofix-form-dropdown>
                    <gofix-form-input label="Contract Name" desc="e.g. Contract with ABC" v-model="contract.contract_name"></gofix-form-input>
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input label="Abbreviation" desc="e.g. AXS" maxlength="3" v-model="contract.abbreviation"></gofix-form-input>
                        </b-col>
                    </b-row>
                    <gofix-form-input-date
                        :minDate="new Date()"
                        required
                        label="Start Date"
                        v-model="contract.start_date" />
                    <gofix-form-input-date
                        :minDate="new Date()"
                        required
                        label="End Date"
                        v-model="contract.end_date" />
                    <gofix-form-dropdown
                            label="Select Timezone"
                            desc="e.g. (GMT +8:00) Beijing, Perth, Singapore, Hong Kong"
                            :disabled="true"
                            v-model="contract.timezone"
                            :options="timezones"
                            vLabel="name">
                    </gofix-form-dropdown>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="saveContract" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal>

            <b-button @click="addItem" :disabled="!$checkRole($accessModule.client_contract_listing, 'create')" class="enabledBtn"><img src="img/enabledBtn.png" alt="" /></b-button>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex'
    import { timezones } from '@/_timezone.js'

    import moment from 'moment';

    export default {
        name: 'client-contract-list',
        components: {},
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['client_contract']));
            return {
                tableConfig:{
                    name: 'client-contract-listing',
                    controls:{
                        create: this.$checkRole(this.$accessModule.client_contract_listing, 'create'),
                        delete: this.$checkRole(this.$accessModule.client_contract_listing, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems:[],
                timezones: timezones,
                clients : [],
                suppliers: [],
                disabled: false,
                contract: {
                    client: null,
                    client_id : '',
                    supplier_id: '',
                    supplier: null,
                    contract_name: '',
                    abbreviation: '',
                    start_date: null,
                    end_date: null,
                    // set default Singapore
                    timezone: timezones.filter(x =>  x["value"] == 8)[0],
                    terms_base: [{
                        term_type: 'base',
                        start_date: '',
                        end_date: '',
                        contract_sum: '0'
                    }],
                    newCustomer : false,
                },
                isAction : false,
                isNewCustomer : false
            }
        },
        filters: {
            // showDate = false: show name term; = true: show end date
            showDateTerm (item, showDate) {
                let terms = item.contract_terms;
                if(terms.length > 1) {
                    for(let i=0; i < terms.length; i++) {
                        if(terms[i].start_date && terms[i].end_date) {
                            let start_date = moment(terms[i].start_date, "YYYY-MM-DD");
                            let end_date = moment(terms[i].end_date, "YYYY-MM-DD");
                            if (moment().isBetween(start_date, end_date, null, '[]')) {
                                if (showDate == 1) {
                                    return end_date.format("DD.MM.YYYY");
                                }
                                if(showDate == 2) {
                                    return terms[0].start_date ? moment(terms[0].start_date).format("DD.MM.YYYY") : '';
                                }
                                return terms[i].term_type + '-term';
                            }
                        }
                    }
                }

                if(terms.length === 1) {
                    if (showDate == 1) {
                        return terms[0].end_date ? moment(terms[0].end_date).format("DD.MM.YYYY") : '';
                    }
                    if(showDate == 2) {
                        return terms[0].start_date ? moment(terms[0].start_date).format("DD.MM.YYYY") : '';
                    }
                    return terms[0].term_type+'-term';
                }
            }
        },
        watch: {
            ClientContractID: async function(val, old) {
                if(val && val.id) {
                    this.$router.push(`/v2/contract-client/${val.id}`)
                }
            },
            "contract.client" : function(val) {
                this.contract.client_id = null;
                if(val && val.id) {
                    this.isNewCustomer        = false;
                    this.contract.newCustomer = false;
                    this.contract.client_id   = val.id;
                }
            },
            "contract.supplier" : function(val) {
                this.contract.supplier_id = val && val.id ? val.id : null;
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                ItemsReadingLog: 'MeterReadingLogController/Items',
                ItemsDevices: 'MeteringDevicesController/Items',
            })
        },
        async created(){
            if(this.ClientContractID) {
                this.$store.commit('ContractController/setClientContractID', null)
            }

            await this.getOrganizations({ is_fm_company: true });
            await this.getOrganizations({ is_supplier: false }, true);
            this.contract.supplier = await this.UserLogin.organization;
        },
        methods:{
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("ContractController/getList", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.contracts;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of client contracts", "danger");
                        reject();
                    })
            },
            timezoneCal(){
                var offset = new Date().getTimezoneOffset();
                var zone = -(offset / 60);
                return zone
            },
            addItem() {
                this.contract.client        = null;
                this.contract.client_id     = '';
                this.contract.contract_name = '';
                this.contract.abbreviation  = '';
                this.contract.newCustomer   = false;
                this.$refs['modal-Contract'].show();
            },
            detailItem(item) {
                this.$router.push(`/v2/contract-client/${item.id}`).catch(err => {})
                this.$store.commit('v2UserController/setListingUser', { items : [], total : 0, pages : { limit : 25, }})
            },            
            saveContract() {
                if(!this.contract.contract_name){
                    return this.$alertNotification("Contract name is required!", "danger");
                }

                if(this.contract.abbreviation.length < 3){
                    return this.$alertNotification("Abbreviation must be 3 characters!", "danger");
                }

                if(!this.contract.supplier){
                    return this.$alertNotification("FM Company is required!", "danger");
                }

                if(!this.contract.start_date){
                    return this.$alertNotification("Start date is required!", "danger");
                }

                if(!this.contract.end_date){
                    return this.$alertNotification("End date is required!", "danger");
                }

                if(!moment(this.contract.end_date).isAfter(this.contract.start_date)) {
                    return this.$alertNotification("End date must be greater than start date!", "danger");
                }

                this.isAction = true
                let requset = JSON.parse(JSON.stringify(this.contract));
                requset.timezone = JSON.stringify(requset.timezone);
                requset.terms_base[0].start_date = moment(new Date(this.contract.start_date)).format('YYYY-MM-DD');
                requset.terms_base[0].end_date   = moment(new Date(this.contract.end_date)).format('YYYY-MM-DD');
                this.$store.dispatch('ContractController/CreateClientContract', requset)
                    .then(async response => {
                        if (response.data.status == 200) {
                            if(response.data.data.code && response.data.data.code == 400 && response.data.data.message){
                                this.isAction = false
                                this.$alertNotification(response.data.data.message, "danger");
                            }else{
                                this.$store.dispatch('ContractController/getClientContractID', response.data.data.id)
                                    .catch(error => {})
                                await this.$router.push(`/v2/contract-client/${response.data.data.id}`)
                                await this.$alertNotification(this.$notificationV2('adding', 'client_contract'));
                            }
                        }
                        this.isAction = false
                    })
                    .catch(error => {
                        this.isAction = false
                        if(error.response) this.$alertNotification("An error occurred! Please try again", "danger");
                    });
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("ContractController/deleteClientContract", ids)
                    .then(response => {
                        this.$store.commit('ContractController/setTotalSupplierContract', 0);
                        this.$store.dispatch( 'MeteringDevicesController/getList', this.ItemsDevices.pages);
                        this.$store.dispatch( 'MeterReadingLogController/getList', this.ItemsReadingLog.pages);
                        resolve(this.$notificationV2('deleting', 'client_contract'))
                    })
                    .catch(err =>{
                        console.error("Got nothing from server. Prompt user to check internet connection and try again")
                    });
            },
            /*---Organizations: client/supplier---*/
            async getOrganizations(filter, is_client = false) {
                await this.$store.dispatch( 'OrganizationController/searchOrganizations', filter)
                .then(response => {
                    if(is_client) {
                        this.clients = response.data.data;
                        return;
                    }
                    this.suppliers = response.data.data;
                })
                .catch(err=>{ 
                    console.log(err);
                })
            },
            searchOrganization(search, loading){
                this.clients = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOrganizations({ is_supplier: false, name: search }, true);
                        await loading(false);
                        if(search) {
                            let isNewCustomer = true;
                            let client  = { id: 0, name: search };
                            let findObj = await this.clients.filter(word => word.name == search);
                            if(findObj.length){
                                client  = findObj[0];
                                isNewCustomer = false;
                                this.contract.newCustomer = false;
                            }

                            this.isNewCustomer   = isNewCustomer;
                            this.contract.client = client;
                        }
                        
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
            searchFMCompany(search, loading){
                this.suppliers = []
                loading(true);
                if(this.fm_timer) {
                    clearTimeout(this.fm_timer);
                    this.fm_timer = null;
                }
                this.fm_timer = setTimeout(async () => {
                    try {
                        await this.getOrganizations({ is_fm_company: true, name: search });
                        await loading(false);
                        // if(search) {
                        //     let supplier = { id: 0, name: search };
                        //     let findObj  = await this.suppliers.filter(word => word.name == search);
                        //     if(findObj.length){
                        //         supplier = findObj[0];
                        //     }

                        //     this.contract.supplier = supplier;
                        // }
                    } catch(err) {
                        loading(false);
                    }
                }, 500);
            },
        }
    }
</script>
